import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { MedialistEntity } from './medialist.entity'

export class MedialistsRepository extends BaseRepository<MedialistEntity> {
    path
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/academy/medialists', token, cache)
        this.path = config.toolsApiUrl + '/academy/medialists'
    }

    async getOnePublic(medialistId: string) {
        const url = this.path + '/' + medialistId + '/public?'
        const { json, statusCode, message } = await this.request.get(url + 'token=' + this.resolvedToken)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getAllPublic(params: any) {
        let queryString = '?'
        for (const key in params) {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') queryString += key + '=' + params[key] + '&'
        }
        const url = this.path + '/public/' + queryString + 'token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
